import React from "react";
import './njitCatalog.scss';
import Image from './9c216316d4ef3d6502477824f849c3b8.png'



export default function CatalogCard({d,i,isProgram,courseCount}){
    var url = d.listing_url;
    var price = 'FREE';
    var triangle = 
    <React.Fragment>
        <div className="triangle"></div>
        <div className="triangle-text">FREE</div>
    </React.Fragment>;
    
    if(d.enrollment_fee!=0){
        price = d.enrollment_fee;
        triangle = "";
    }

    var options = { month: 'short', day: 'numeric', year: 'numeric' };
    if(d.start_date){
           var start_date = new Date(d.start_date);
           var formattedStartDate = start_date.toLocaleDateString('en-US', options);
    }
    if(d.end_date){
           var end_date = new Date(d.end_date);
           var formattedEndDate = end_date.toLocaleDateString('en-US', options);
    }

    var date = 'Self-paced';

    if(d.start_date && d.end_date){
        date = formattedStartDate + ' - ' + formattedEndDate;
    }

    return(
        <a href={url}>
            <div className={price=='FREE'? "item free": "item"}>
                {triangle}
                <img src={d.listing_image} alt="image" className="image" />
                <div className="card-content">
                                    <div className="item-header">
                    <div className="course-info">
                        <span>{isProgram ? `Program | ${courseCount + 1} Courses` : "Course"}</span>
                        <span className="price">{price == 'FREE' ? price : '$' + price}</span>
                    </div>
                    <div className="course-title">
                        {d.title}
                    </div>
                </div>
                    <div className="item-body">
                        <div className="course-description truncate-text">{d.short_description}</div>
                        <div className="logo-img">
                        <img src="https://catalog-prod-s3-gallerys3-skf57zr7pimb.s3.amazonaws.com/production/logos/43f5414e-86c6-4998-8238-ee17ea90aa38.png"/>
                        </div>
                    </div>
                    <div className="item-footer">
                        <div className="item-footer-left">
                            <div class="course-date">{date}</div>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    )
}


// WEBPACK FOOTER //
// ./src/Catalog/njitCatalogCard.js